import "core-js/modules/es.array.map.js";
export default (function () {
  var selectors = ['.mobile-carousel', '.header-image-container'];
  selectors.map(function (selector) {
    document.querySelector(selector) && document.querySelector(selector).childElementCount > 1 && $(selector).slick({
      prevArrow: '<i class="slick-prev fa fa-angle-left"></i>',
      nextArrow: '<i class="slick-next fa fa-angle-right"></i>'
    });
  });
});